import { ToastrService } from 'ngx-toastr';
import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiService } from './api.service';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class ApiExtendedService extends ApiService<any> {
  constructor(
    @Inject(HttpClient) http,
    toast: ToastrService,
    _cookie: CookieService) {
    super(http, toast, _cookie);
  }
}
